export const environment = {
  //SSO APIs
  SSOauthAPI: "https://api.auth.myzpax.com/api",
  ssoUserInfoAPI: "https://api.auth.myzpax.com/connect/userinfo",
  ssoConnectAPI: "https://api.auth.myzpax.com/connect/authorize",
  ssoLogoutAPI: "https://api.auth.myzpax.com/api/account/logout",
  ssoLoginUrl: "https://auth.myzpax.com/sso/login",

  endpoint: "https://api.rehabconnect.com/api/v1",

  zpaxEsignatureDocumentRedirectEndPoint:
    "https://myzpax.com/app/document-signature/documents",
  zpaxChangepasswordEndpoint: "https://myzpax.com/user/password-and-security",
  zpaxPrivacyPolicyEndPoint: "https://myzpax.com/privacy.html",
  zpaxTermsEndPoint: "https://myzpax.com/terms.html",

  sessionEncryptionKey:
    "fCCmUMuOM0kuDCuLe7naPOo6sNvlhXshFhZEVomw5XAS9vR7M0YGxbeaeYhiNmOC",
  idleTimeBeforeLocking: 3600,
  idleTimeBeforeTerminating: 4200,
  clientId: "b36f97928dac466a86f1d0e0494eab10",
  userDetailsAPI: "/user/get",
  authorizationAPI: "/authorization",
  AWS_REGION: "us-east-1",
  AWS_ACCESS_KEY_ID: "",
  AWS_SECRET_ACCESS_KEY: "",
  AWS_SESSION_TOKEN: "",
  biDashboardSupersetDomain: "https://6cef2d04.us1a.app.preset.io",

  /**Matomo Analytics */
  enableMatomo: true,
  matomo: {
    trackerUrl: "https://matomo.z-pax.com/",
    siteId: 6
  },

  /**Pagesense */
  enablePagesense: true,
  pagesenseUrl: "https://cdn.pagesense.io/js/rehabconnectllc/248e77f07da445d09d4873cffda8ad37.js",

  enableNewReactApp: false,
  postMessageTargets: ['https://myzpax.com'],
  supportEmail: 'support@rehabconnect.com',

  /** CMI Connect Therapy Referrals iframe */
  therapyReferralUrl:
    "https://api.auth.myzpax.com/connect/authorize?client_id=cmi_connect&redirect_uri=https%3A%2F%2Fcmiconnect.com%2Fdashboard?embed=therapy&response_type=code&scope=offline_access%20email%20profile&fallback_uri=https%3A%2F%2Fz-pax.com%2Fcmi-connect&prompt=none",
  /** "Open full app" target for the Therapy Referrals embed - launches CMI Connect through the MyZPAX portal directly, outside the iframe. */
  therapyReferralFullAppUrl: "https://myzpax.com/connect",
};
